import { Button } from '@skupreme/shared/ui';

interface IAwaitConfirmation {
  confirm: () => void;
  isAdmin: boolean;
}

export function AwaitConfirmation({ confirm, isAdmin }: IAwaitConfirmation) {
  return (
    <div className="sk:flex sk:flex-wrap sk:items-center sk:justify-between sk:gap-4 sk:p-4">
      <p className="sk:m-0 sk:max-w-88 sk:text-sm sk:text-fg">
        The purchase order is awaiting supplier confirmation. We&apos;ve sent a
        confirmation e-mail to your supplier for review. You can also override
        this and confirm the PO manually.
      </p>
      <Button isDisabled={!isAdmin} onPress={() => isAdmin && confirm()}>
        Confirm Purchase Order
      </Button>
    </div>
  );
}
